import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Lightbox from '../components/Lightbox';
import FAQSection from '../components/FAQSection';
import SEO from '../components/SEO';
import { getIconClass, sortServices } from '../lib/utils';

// Mapping of services to their portfolio images (including the user's uploaded images)
const SERVICE_IMAGES_MAP = {
  'garageporte': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-2-webp-20210903-1417121360-30-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-3-webp-20210527-1615161372-27-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-4-webp-20210319-0942121369-rotated-24-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-5-webp-20201031-1536121381-21-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-6-webp-20201031-1536211382-22-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-28-webp-203681113-108732488121632-1356192873726817986-n-1-35-11zon.png"
  ],
  'friporte': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-10-webp-20201014-1721021380-rotated-20-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/20191129-105312-scaled-1-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-7-webp-20190919-1442301395-9-11zon-600x400.png"
  ],
  'industriporte': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-20200922-1456141392-rotated-17-11zon-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-20210909-1518551362-32-11zon-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-203681113-108732488121632-1356192873726817986-n-1-35-11zon-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-20200924-1413351393-18-11zon-600x400.webp"
  ],
  'portservice-og-lovpligtigt-eftersyn': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-portservise-cover-2-85-11zon.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-img-20220117-083136-01-scaled-68-11zon.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-img20240717114443-69-11zon-600x400.webp"
  ],
  'lovpligtigt-eftersyn': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-portservise-cover-2-85-11zon.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-img-20220117-083136-01-scaled-68-11zon.webp"
  ],
  'garageporte-og-industriporte': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-2-webp-20210903-1417121360-30-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-3-webp-20210527-1615161372-27-11zon-600x400.png"
  ],
  'garageporte-og-tilbehoer': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-20190919-1442301395-9-11zon-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-highend-elbetjeninger-65-11zon.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-fjernbetjeninger-62-11zon.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-ismartgate-72-11zon.webp"
  ],
  'hurtigporte': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-portservise-aboutimage-3-83-11zon-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-11-webp-20210603-1516391373-rotated-28-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-12-webp-203681113-108732488121632-1356192873726817986-n-1-35-11zon-600x400.png"
  ],
  'laager-og-laageautomatik': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/20191129-105312-scaled-1-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-7-webp-20190919-1442301395-9-11zon-600x400.png",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-8-webp-20191028-0819151397-11-11zon-600x400.png"
  ],
  'frostporte-og-frostdoere': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-267290214-203222105339336-3933764854435164765-n-38-11zon-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-13-webp-20210909-1518551362-32-11zon-600x400.png"
  ],
  'ramper-og-sluser': [
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-20200922-1456141392-rotated-17-11zon-600x400.webp",
    "https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-fb-img-1642448351158-1-61-11zon-600x400.webp"
  ]
};

const GARAGEPORTE_FAQ = [
  {
    question: "Hvor godt isolerer en moderne garageport, og kan den holde garagen frostfri?",
    answer: "Vores isolerede ledhejseporte leveres med 40–46 mm opskummede sandwichpaneler af stål samt slidstærke tætningslister hele vejen rundt i karmen og langs gulvet. Den høje isoleringsevne minimerer kuldebroer og træk markant, så du nemt kan opretholde en stabil og frostfri temperatur i garagen igennem hele vinterhalvåret. Det gør rummet yderst velegnet til både bilparkering, værksted, hobbyrum og frostfølsom opbevaring."
  },
  {
    question: "Hvad gør man ved strømsvigt – kan en automatisk garageport åbnes manuelt?",
    answer: "Ja, alle vores el-drevne garageporte er udstyret med en integreret mekanisk nødudløser. Skulle strømmen gå, trækker du blot i det indvendige nødudløserkabel, hvorefter porten frakobles motoren og let kan løftes manuelt ved hjælp af fjederafbalanceringen. Har din garage ingen anden indgangsdør, monterer vi en diskret udvendig nødfrakobling med nøgle, så du altid er sikret adgang udefra."
  },
  {
    question: "Hvilke sikkerhedsfunktioner beskytter børn, kæledyr og biler mod at komme i klemme?",
    answer: "Vores garageporte overholder alle europæiske sikkerhedskrav (EN 13241-1) med patenteret fingerbeskyttelse mellem alle sektioner, så fingre ikke kan komme i klemme under åbning og lukning. Portautomatikken har intelligent kraftovervågning, der omgående stopper og reverserer porten, hvis den møder den mindste modstand. Derudover er porten udstyret med integreret faldsikring og kan udvides med fotoceller."
  },
  {
    question: "Hvor lang tid tager levering og montering af en ny skræddersyet garageport?",
    answer: "Fra den personlige opmåling og rådgivning på din adresse til porten er færdigproduceret efter dine eksakte mål, farver og profiler, går der typisk 3–5 uger. Selve montagen – inklusive nedtagning af eventuel eksisterende port, opretning af karm, montering af skinner og motortilslutning – klares normalt på under én enkelt arbejdsdag. Vi sørger altid for grundig instruktion samt bortkørsel af den gamle port efter aftale."
  },
  {
    question: "Hvor ofte bør en garageport serviceres, og hvordan vedligeholder man den bedst?",
    answer: "Vi anbefaler et professionelt serviceeftersyn hvert 1–2 år, hvor fjederspænding, wirer, rullelejer, hængsler og motorens elektroniske sikkerhedsstop kontrolleres og fintunes. I hverdagen kan du selv forlænge portens levetid ved regelmæssigt at fjerne blade og grus fra køreskinnerne samt smøre de bevægevæsentlige hængsler med en egnet silikonespray. Regelmæssig pleje modvirker slid og sikrer støjsvag drift."
  }
];

const INDUSTRIPORTE_FAQ = [
  {
    question: "Hvilke lovkrav gælder for det årlige sikkerhedseftersyn af industriporte?",
    answer: "Ifølge Arbejdstilsynets bekendtgørelser er det et lovkrav, at alle motordrevne industriporte, hurtigporte og læsseramper efterses mindst én gang hver 12. måned af en sagkyndig person. Ved eftersynet gennemgås mekaniske dele, fjedre, wirer, faldsikringer samt klemsikringer og nødstop for at forebygge arbejdsulykker. Pabst Teknik udsteder den lovpligtige servicerapport og godkendelsesmærkat på stedet, så I altid har dokumentationen i orden."
  },
  {
    question: "Hvor hurtigt kan Pabst Teknik rykke ud ved akut driftsstop på en industriport?",
    answer: "Vi ved, at en blokeret eller påkørt industriport øjeblikkeligt standser varemodtagelse, forsendelse og intern produktion, hvilket hurtigt medfører store driftsmæssige omkostninger. Derfor yder vi hurtig udrykning i Vejen, Kolding, Christiansfeld, Fredericia, Vejle, Billund og hele Trekantsområdet. Vores servicebiler medbringer specialudstyr og de mest almindelige reservedele, så vi oftest kan udbedre fejlen ved første udkald."
  },
  {
    question: "Hvilken type industriport egner sig bedst til henholdsvis opvarmet lager og frysehus?",
    answer: "Valget afhænger primært af bygningens temperaturkrav, lofthøjde og den daglige trafikintensitet gennem portåbningen. Til opvarmede lager- og produktionshaller anbefaler vi kraftigt isolerede ledhejseporte med 46 mm paneler for minimalt varmetab, eventuelt med fuldvision-lyspaneler. Til fryserum og temperaturfølsomme zoner er specialisolerede frostporte eller lynhurtige hurtigporte med termodug den mest energieffektive løsning."
  },
  {
    question: "Kan I udføre service og reparation på vores eksisterende porte af andre fabrikater?",
    answer: "Ja, hos Pabst Teknik har vi mange års teknisk erfaring med servicering og reparation af alle etablerede portmærker, herunder fx Lindab, Crawford, Hörmann, Nassau, Faltec og mange flere. Vores montører kender mekanikken og styringerne på tværs af fabrikater og årgange. Vi skaffer hurtigt originale reservedele og giver altid en ærlig vurdering af, om reparation eller udskiftning er mest økonomisk fordelagtig."
  },
  {
    question: "Hvilke automatiserings- og adgangsløsninger kan integreres med industriportene?",
    answer: "Vi tilbyder et bredt spektrum af automatiske betjeningsløsninger, der optimerer virksomhedens interne logistik og minimerer unødig åbningstid. Dette omfatter intelligente radarer med skelnen mellem trucks og gående, magnetsløjfer i gulvet, trådløse trækkontakter, fjernbetjeninger samt kodetastaturer og brik-adgang. Derudover kan portene fuldt integreres med Ajax sikrings- og alarmsystemer for maksimal kontrol."
  }
];

function formatDescriptionWithFrontpageLink(html) {
  if (!html) return '';
  let replaced = false;
  return html.replace(/(<(h[1-6]|a)[^>]*>[\s\S]*?<\/\2>)|(\b(?:Pabst\s+Teknik(?:\s+ApS)?|Pabst\s+teknik(?:\s+ApS)?|pabstteknik)\b)/gi, (match, headingOrLink, tag, companyName) => {
    if (headingOrLink) {
      return headingOrLink;
    }
    if (!replaced && companyName) {
      replaced = true;
      return `<a href="/" class="text-brand-dark font-semibold hover:text-brand-accent transition-colors underline decoration-brand-accent/40 decoration-2 underline-offset-2">${companyName}</a>`;
    }
    return match;
  });
}

export default function ServiceDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [otherServices, setOtherServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  useEffect(() => {
    setLoading(true);
    setActiveImageIndex(0);
    fetch('https://api.dev.auxo.dk/public/content/services')
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          // Find the service that matches the slug
          // Note: the CMS slug field is under service.slug.da or service.service_slug
          const found = data.find(s => s.service_slug === slug || (s.slug && s.slug.da === slug));
          if (found) {
            setService(found);
            setOtherServices(sortServices(data.filter(s => s.id !== found.id)));
            
            // Set metadata
            document.title = `${found.title.da} - Pabst Teknik ApS`;
            const metaDesc = document.querySelector('meta[name="description"]');
            if (metaDesc) {
              metaDesc.setAttribute('content', found.summary.da);
            }
          } else {
            // If service not found, redirect to 404
            navigate('/404', { replace: true });
          }
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching service detail:', err);
        setLoading(false);
      });
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-32 gap-4 bg-brand-bg">
        <i className="fa-solid fa-spinner animate-spin text-4xl text-brand-accent" />
        <p className="text-sm font-semibold text-slate-500">Henter detaljer for ydelsen...</p>
      </div>
    );
  }

  if (!service) return null;

  return (
    <div className="bg-brand-bg">
      <SEO
        title={`${service.title.da}`}
        description={`${service.summary.da} Læs mere om ${service.title.da} hos Pabst Teknik ApS i Vejen. Få rådgivning og uforpligtende tilbud.`}
        url={`/ydelser/${slug}`}
        image={service.image && service.image[0] ? service.image[0] : undefined}
        keywords={`${service.title.da}, portservice, portmontør, eftersyn, Pabst Teknik, Vejen, Syddanmark`}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: service.title.da,
          description: service.summary.da,
          provider: {
            '@type': 'HomeAndConstructionBusiness',
            name: 'Pabst Teknik ApS',
            telephone: '+4521684422',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Gestenvej 29',
              addressLocality: 'Vejen',
              postalCode: '6600',
              addressCountry: 'DK'
            }
          },
          areaServed: 'Danmark',
          serviceType: service.title.da
        }}
      />
      {/* Page Header */}
      <section className="relative bg-gradient-to-br from-slate-950 via-brand-dark to-brand-accent/20 text-white px-6 py-24 md:py-32 overflow-hidden">
        {/* Background Image with Blend Mode */}
        <div className="absolute inset-0 opacity-15 mix-blend-overlay">
          <img
            src={`${SERVICE_IMAGES_MAP[service.service_slug]?.[0] || (service.slug && SERVICE_IMAGES_MAP[service.slug.da]?.[0]) || (service.image && service.image[0]) || 'https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-starterkit-cam-plus-89-11zon.webp'}?cdn-cgi/image/width=1600,quality=80,format=auto`}
            alt={`${service.title.da} - Professionel port- og sikringsløsning fra Pabst Teknik ApS`}
            className="h-full w-full object-cover"
          />
        </div>
        
        {/* Subtle Tech Grid Overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(2,132,199,0.08)_1px,transparent_1px),linear-gradient(to_bottom,rgba(2,132,199,0.08)_1px,transparent_1px)] bg-[size:3rem_3rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
        
        {/* Glowing Ambient Light */}
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-accent/20 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-brand-accent/10 rounded-full blur-3xl pointer-events-none" />

        <div className="mx-auto max-w-7xl relative z-10 flex flex-col gap-6 items-center text-center">
          {/* Breadcrumb Navigation */}
          <nav aria-label="Brødkrummesti" className="flex items-center gap-2 text-xs sm:text-sm font-medium text-slate-300">
            <Link to="/" className="hover:text-white transition-colors flex items-center gap-1.5">
              <i className="fa-solid fa-house text-xs text-brand-accent" />
              <span>Forside</span>
            </Link>
            <i className="fa-solid fa-chevron-right text-[10px] text-slate-400" />
            <Link to="/ydelser" className="hover:text-white transition-colors">
              Ydelser
            </Link>
            <i className="fa-solid fa-chevron-right text-[10px] text-slate-400" />
            <span className="text-brand-accent font-semibold truncate max-w-[200px] sm:max-w-none" aria-current="page">
              {service.title.da}
            </span>
          </nav>

          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-6xl font-display">
            {service.title.da}
          </h1>
          
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed font-sans">
            {service.summary.da}
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="relative z-20 px-6 pb-24 md:pb-32">
        <div className="mx-auto max-w-7xl -mt-12 bg-white rounded-3xl border border-slate-100 p-8 md:p-16 shadow-xl">
          <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 items-start">
            {/* Left Side: Service Details */}
            <div className="lg:col-span-8 flex flex-col gap-8">
              {/* Service Image Slider */}
              {(() => {
                const sliderImages = SERVICE_IMAGES_MAP[service.service_slug] || 
                                     (service.slug && SERVICE_IMAGES_MAP[service.slug.da]) || 
                                     (service.image && service.image.length > 0 ? service.image : ['https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-starterkit-cam-plus-89-11zon.webp']);
                
                const hasMultiple = sliderImages.length > 1;

                const handlePrev = () => {
                  setActiveImageIndex((prev) => (prev === 0 ? sliderImages.length - 1 : prev - 1));
                };

                const handleNext = () => {
                  setActiveImageIndex((prev) => (prev === sliderImages.length - 1 ? 0 : prev + 1));
                };

                const handleTouchStart = (e) => {
                  setTouchEnd(null);
                  setTouchStart(e.targetTouches[0].clientX);
                };

                const handleTouchMove = (e) => {
                  setTouchEnd(e.targetTouches[0].clientX);
                };

                const handleTouchEnd = () => {
                  if (!touchStart || !touchEnd) return;
                  const distance = touchStart - touchEnd;
                  const minSwipeDistance = 50;
                  if (distance > minSwipeDistance) {
                    handleNext();
                  } else if (distance < -minSwipeDistance) {
                    handlePrev();
                  }
                };

                return (
                  <div className="flex flex-col gap-4">
                    {/* Main Viewport */}
                    <div 
                      className="relative overflow-hidden rounded-3xl border border-slate-100 shadow-lg aspect-[16/9] bg-slate-50 group"
                      onTouchStart={handleTouchStart}
                      onTouchMove={handleTouchMove}
                      onTouchEnd={handleTouchEnd}
                    >
                      {/* Image */}
                      <img
                        src={`${sliderImages[activeImageIndex]}?cdn-cgi/image/width=1200,quality=85,format=auto`}
                        alt={`${service.title.da} - Detaljebillede ${activeImageIndex + 1} af ${sliderImages.length} hos Pabst Teknik`}
                        className="h-full w-full object-cover select-none transition-all duration-500"
                        draggable={false}
                      />

                      {/* Overlays & Navigation */}
                      {hasMultiple && (
                        <>
                          {/* Left Arrow */}
                          <button
                            onClick={handlePrev}
                            className="absolute left-4 top-1/2 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-white/80 text-brand-dark shadow-md backdrop-blur-sm transition-all hover:bg-white hover:scale-105 active:scale-95 opacity-0 group-hover:opacity-100 focus:opacity-100"
                            aria-label="Forrige billede"
                          >
                            <i className="fa-regular fa-chevron-left text-lg" />
                          </button>

                          {/* Right Arrow */}
                          <button
                            onClick={handleNext}
                            className="absolute right-4 top-1/2 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-white/80 text-brand-dark shadow-md backdrop-blur-sm transition-all hover:bg-white hover:scale-105 active:scale-95 opacity-0 group-hover:opacity-100 focus:opacity-100"
                            aria-label="Næste billede"
                          >
                            <i className="fa-regular fa-chevron-right text-lg" />
                          </button>
                        </>
                      )}

                      {/* Zoom / Fullscreen Button */}
                      <button
                        onClick={() => setLightboxIndex(activeImageIndex)}
                        className="absolute right-4 bottom-4 flex h-11 w-11 items-center justify-center rounded-full bg-brand-dark/80 text-white shadow-md backdrop-blur-sm transition-all hover:bg-brand-dark hover:scale-105 active:scale-95"
                        aria-label="Åben fuldskærm"
                      >
                        <i className="fa-regular fa-magnifying-glass-plus text-base" />
                      </button>

                      {/* Badge Indicator */}
                      {hasMultiple && (
                        <span className="absolute left-4 bottom-4 rounded-full bg-brand-dark/75 px-3 py-1 text-xs font-semibold text-white backdrop-blur-sm">
                          {activeImageIndex + 1} / {sliderImages.length}
                        </span>
                      )}
                    </div>

                    {/* Thumbnail Track */}
                    {hasMultiple && (
                      <div className="flex items-center gap-2 overflow-x-auto py-1 scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent">
                        {sliderImages.map((img, idx) => (
                          <button
                            key={idx}
                            onClick={() => setActiveImageIndex(idx)}
                            className={`relative h-16 w-24 shrink-0 overflow-hidden rounded-xl border-2 transition-all ${
                              activeImageIndex === idx 
                                ? 'border-brand-accent shadow-sm scale-95' 
                                : 'border-slate-100 opacity-60 hover:opacity-100'
                            }`}
                          >
                            <img
                              src={`${img}?cdn-cgi/image/width=200,quality=75,format=auto`}
                              alt={`${service.title.da} - Miniaturebillede ${idx + 1}`}
                              className="h-full w-full object-cover"
                            />
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Lightbox Integration */}
                    {lightboxIndex !== null && (
                      <Lightbox
                        images={sliderImages}
                        currentIndex={lightboxIndex}
                        onClose={() => setLightboxIndex(null)}
                        onPrev={() => setLightboxIndex((prev) => (prev === 0 ? sliderImages.length - 1 : prev - 1))}
                        onNext={() => setLightboxIndex((prev) => (prev === sliderImages.length - 1 ? 0 : prev + 1))}
                      />
                    )}
                  </div>
                );
              })()}

              {/* Rich Text Description */}
              {service.service_slug === 'garageporte' ? (
                <div className="flex flex-col gap-10 text-slate-700">
                  {/* Hero Intro Card */}
                  <div className="rounded-2xl bg-slate-50 border border-slate-100 p-6 md:p-8 flex flex-col gap-4">
                    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent">
                      <i className="fa-solid fa-house-chimney-window" />
                      <span>Garageporte til private</span>
                    </div>
                    <h2 className="text-2xl md:text-3xl font-extrabold text-brand-dark font-display">
                      Garageporte, der gør hverdagen lettere
                    </h2>
                    <p className="text-base text-slate-600 leading-relaxed">
                      En garageport skal fungere sikkert hver dag, passe til husets udtryk og være nem at betjene. Hos <Link to="/" className="text-brand-dark font-semibold hover:text-brand-accent transition-colors underline decoration-brand-accent/40 decoration-2 underline-offset-2">Pabst Teknik</Link> hjælper vi med garageporte til private, fra rådgivning og valg af port til garage til professionel montage, løbende service og reparation.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-2">
                      <div className="flex items-center gap-2 text-xs font-semibold text-slate-700 bg-white p-3 rounded-xl border border-slate-100 shadow-2xs">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Faglig rådgivning</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs font-semibold text-slate-700 bg-white p-3 rounded-xl border border-slate-100 shadow-2xs">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Professionel montage</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs font-semibold text-slate-700 bg-white p-3 rounded-xl border border-slate-100 shadow-2xs">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Lokal service & rep.</span>
                      </div>
                    </div>
                  </div>

                  {/* Section 1: Hvilken port passer bedst */}
                  <div className="flex flex-col gap-5">
                    <h3 className="text-xl md:text-2xl font-bold text-brand-dark font-display flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent text-sm">
                        <i className="fa-regular fa-compass-drafting" />
                      </span>
                      Hvilken port til garage passer bedst til dit hjem
                    </h3>
                    <div className="space-y-4 text-slate-600 leading-relaxed">
                      <p>
                        Den rette løsning afhænger af åbningens mål, pladsen omkring porten og den måde, du bruger garagen på. Vi ser også på ønsket isolering, overflade og betjening, så du får en port, der passer til både bygningen og dine daglige rutiner.
                      </p>
                      <p>
                        En velvalgt port til garage handler derfor om mere end farve og design. Konstruktion, tæthed og korrekt montering har betydning for komforten, mens fingerbeskyttelse og en stabil bevægelse bidrager til sikker brug for hele familien.
                      </p>
                    </div>

                    {/* 4 Decision factors grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                      <div className="flex items-start gap-3 p-4 rounded-xl border border-slate-100 bg-white shadow-2xs hover:border-brand-accent/30 transition-colors">
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                          <i className="fa-regular fa-ruler-combined" />
                        </span>
                        <div>
                          <h4 className="text-sm font-bold text-brand-dark">Mål og pladsforhold</h4>
                          <p className="text-xs text-slate-500 mt-0.5">Åbningens mål og pladsen omkring porten.</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3 p-4 rounded-xl border border-slate-100 bg-white shadow-2xs hover:border-brand-accent/30 transition-colors">
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                          <i className="fa-regular fa-snowflake" />
                        </span>
                        <div>
                          <h4 className="text-sm font-bold text-brand-dark">Isolering & tæthed</h4>
                          <p className="text-xs text-slate-500 mt-0.5">Behovet for isolering og optimal tæthed.</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3 p-4 rounded-xl border border-slate-100 bg-white shadow-2xs hover:border-brand-accent/30 transition-colors">
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                          <i className="fa-regular fa-palette" />
                        </span>
                        <div>
                          <h4 className="text-sm font-bold text-brand-dark">Farve & design</h4>
                          <p className="text-xs text-slate-500 mt-0.5">Ønsket farve, overflade og udformning.</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3 p-4 rounded-xl border border-slate-100 bg-white shadow-2xs hover:border-brand-accent/30 transition-colors">
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                          <i className="fa-regular fa-bolt" />
                        </span>
                        <div>
                          <h4 className="text-sm font-bold text-brand-dark">Betjening</h4>
                          <p className="text-xs text-slate-500 mt-0.5">Manuel betjening eller elektrisk automatik.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Section 2: Få garageporten tilpasset huset og åbningen */}
                  <div className="flex flex-col gap-4 p-6 md:p-7 rounded-2xl bg-gradient-to-br from-slate-50 to-sky-50/40 border border-slate-100">
                    <h3 className="text-xl md:text-2xl font-bold text-brand-dark font-display flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent text-sm">
                        <i className="fa-regular fa-sliders" />
                      </span>
                      Få garageporten tilpasset huset og åbningen
                    </h3>
                    <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                      Garageporte kan tilpasses i farve og udformning, så porten falder naturligt ind i boligen. De beskrevne løsninger kan leveres med en isolerende kerne, robuste stålplader og fingerbeskyttelse. Vi rådgiver ud fra den konkrete garage og dine ønsker.
                    </p>
                    <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                      Ved valg af løsning tager vi udgangspunkt i portåbningen og forholdene omkring den. Det mindsker risikoen for, at design eller funktion vælges på et forkert grundlag. Du får en samlet dialog om port, tilpasning og montage, før arbejdet sættes i gang.
                    </p>
                  </div>

                  {/* Section 3: Komfort, isolering og nem betjening */}
                  <div className="flex flex-col gap-5">
                    <h3 className="text-xl md:text-2xl font-bold text-brand-dark font-display flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent text-sm">
                        <i className="fa-regular fa-shield-heart" />
                      </span>
                      Få komfort, isolering og nem betjening i samme port
                    </h3>
                    <div className="space-y-4 text-slate-600 leading-relaxed text-sm md:text-base">
                      <p>
                        Vil du kunne åbne garagen uden at stige ud af bilen, kan elektrisk betjening være den praktiske løsning. En port med automatik gør adgangen lettere i hverdagen, mens en manuel model kan være relevant, hvis behovet er enklere. Vi hjælper med at afklare mulighederne.
                      </p>
                      <p>
                        Bruger du garagen som værksted, opbevaring eller adgang til boligen, er isolering og tæthed ofte vigtige punkter. Den rette garageport kan begrænse træk og gøre rummet mere anvendeligt, men løsningen skal altid vælges efter bygningen og den faktiske brug.
                      </p>
                    </div>

                    {/* 4 Feature highlight cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col gap-2">
                        <div className="flex items-center gap-2 text-brand-dark font-bold text-sm">
                          <i className="fa-solid fa-shield-check text-brand-accent" />
                          <span>Isolerende kerne & robust stålplade</span>
                        </div>
                        <p className="text-xs text-slate-500 leading-relaxed">
                          Effektiv kerne begrænser træk og varmetab, mens den stærke stålplade sikrer lang levetid og modstandsdygtighed.
                        </p>
                      </div>

                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col gap-2">
                        <div className="flex items-center gap-2 text-brand-dark font-bold text-sm">
                          <i className="fa-solid fa-hand-holding-hand text-brand-accent" />
                          <span>Fingerbeskyttelse til sikker betjening</span>
                        </div>
                        <p className="text-xs text-slate-500 leading-relaxed">
                          Patenteret klemsikring mellem portsektionerne, så hele familien trygt kan færdes omkring porten.
                        </p>
                      </div>

                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col gap-2">
                        <div className="flex items-center gap-2 text-brand-dark font-bold text-sm">
                          <i className="fa-solid fa-car text-brand-accent" />
                          <span>Elektrisk åbning fra bilen</span>
                        </div>
                        <p className="text-xs text-slate-500 leading-relaxed">
                          Kør direkte ind uden at stige ud i regn og slud. Åbn og luk nemt via håndsender, trådløst tastatur eller mobil-app.
                        </p>
                      </div>

                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col gap-2">
                        <div className="flex items-center gap-2 text-brand-dark font-bold text-sm">
                          <i className="fa-solid fa-door-open text-brand-accent" />
                          <span>Port med dør ved gangadgang</span>
                        </div>
                        <p className="text-xs text-slate-500 leading-relaxed">
                          Praktisk integreret dør (gangdør), når du hyppigt skal ind og ud af garagen uden at åbne hele porten.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Section 4: Sådan sammenligner du garageporte tilbud */}
                  <div className="p-6 md:p-8 rounded-3xl bg-slate-900 text-white shadow-lg relative overflow-hidden flex flex-col gap-5">
                    <div className="absolute top-0 right-0 -mt-8 -mr-8 w-40 h-40 bg-brand-accent/20 rounded-full blur-2xl pointer-events-none" />
                    
                    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent-light">
                      <i className="fa-regular fa-scale-balanced" />
                      <span>Rådgivning før køb</span>
                    </div>

                    <h3 className="text-xl md:text-2xl font-bold font-display text-white">
                      Sådan sammenligner du garageporte tilbud
                    </h3>

                    <div className="space-y-4 text-slate-300 leading-relaxed text-sm md:text-base">
                      <p>
                        Når du sammenligner garageporte tilbud, bør du se på mere end selve portens pris. Mål, tilpasning, isolering, betjening og montage påvirker den samlede løsning. Det er også værd at undersøge, om du kan få hjælp til service og reparation, når porten senere får brug for det.
                      </p>
                      <p>
                        Hos Pabst Teknik får du rådgivning med udgangspunkt i din garage og dine ønsker. Det gør tilbuddet nemmere at vurdere, fordi de relevante valg er tænkt med fra starten. Kontakt os for et uforpligtende tilbud på en ny garageport med den montage og funktion, du har brug for.
                      </p>
                    </div>

                    <div className="pt-2 flex flex-wrap items-center gap-4">
                      <Link
                        to="/kontakt"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-brand-accent text-white font-bold text-sm hover:bg-brand-accent-hover transition-colors shadow-md"
                      >
                        <span>Få et uforpligtende tilbud</span>
                        <i className="fa-regular fa-arrow-right text-xs" />
                      </Link>
                      <a
                        href="tel:+4521684422"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-white/10 text-white font-semibold text-sm hover:bg-white/20 transition-colors"
                      >
                        <i className="fa-regular fa-phone text-brand-accent" />
                        <span>Ring 21 68 44 22</span>
                      </a>
                    </div>
                  </div>

                  {/* Section 5: Montage og service giver værdi efter købet */}
                  <div className="flex flex-col gap-4">
                    <h3 className="text-xl md:text-2xl font-bold text-brand-dark font-display flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent text-sm">
                        <i className="fa-regular fa-wrench" />
                      </span>
                      Montage og service giver værdi efter købet
                    </h3>
                    <div className="space-y-4 text-slate-600 leading-relaxed text-sm md:text-base">
                      <p>
                        En ny port skal monteres korrekt, hvis bevægelse, tæthed og betjening skal fungere som tiltænkt. Vi står både for montage og den efterfølgende service. Har du allerede en port, kan vi også undersøge fejl og udføre reparation på forskellige fabrikater.
                      </p>
                      <p>
                        Regelmæssig service kan opdage slitage, før den udvikler sig til en større fejl. Det er særligt relevant for elektriske garageporte med automatik og flere bevægelige dele. Vi servicerer forskellige fabrikater og hjælper med at bevare en stabil og sikker funktion.
                      </p>
                    </div>
                  </div>

                  {/* Section 6: Lokal hjælp med base i Vejen */}
                  <div className="p-6 md:p-7 rounded-2xl bg-white border border-slate-100 shadow-sm flex flex-col gap-4">
                    <h3 className="text-xl md:text-2xl font-bold text-brand-dark font-display flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent text-sm">
                        <i className="fa-regular fa-location-dot" />
                      </span>
                      Lokal hjælp til garageporte med base i Vejen
                    </h3>
                    <div className="space-y-3 text-slate-600 leading-relaxed text-sm md:text-base">
                      <p>
                        Vi har base i Vejen og hjælper private med garageporte i Kolding, Christiansfeld, Fredericia, Vejle, Billund og det øvrige Trekantsområde. Har din virksomhed eller dit landbrug også brug for robuste ledhejseporte, leverer og servicerer vi desuden professionelle <Link to="/ydelser/industriporte" className="text-brand-dark font-semibold hover:text-brand-accent transition-colors underline decoration-brand-accent/40 decoration-2 underline-offset-2">industriporte</Link> i hele området. Den lokale forankring betyder, at du kan samle rådgivning, montage og senere service hos en portvirksomhed i området.
                      </p>
                      <p>
                        Uanset om du udskifter en ældre port eller planlægger en løsning til en ny garage, begynder vi med behovet. Vi rådgiver om funktion, udtryk og betjening uden at gøre valget mere kompliceret end nødvendigt. Målet er en løsning, der passer til hverdagen.
                      </p>
                    </div>

                    {/* City area tags */}
                    <div className="flex flex-wrap gap-2 pt-2">
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-sky-50 text-brand-dark text-xs font-bold border border-sky-100">
                        <i className="fa-solid fa-map-pin text-brand-accent text-[10px]" /> Vejen (Base)
                      </span>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-slate-50 text-slate-700 text-xs font-semibold border border-slate-100">
                        Kolding
                      </span>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-slate-50 text-slate-700 text-xs font-semibold border border-slate-100">
                        Christiansfeld
                      </span>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-slate-50 text-slate-700 text-xs font-semibold border border-slate-100">
                        Fredericia
                      </span>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-slate-50 text-slate-700 text-xs font-semibold border border-slate-100">
                        Vejle
                      </span>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-slate-50 text-slate-700 text-xs font-semibold border border-slate-100">
                        Billund
                      </span>
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-slate-50 text-slate-700 text-xs font-semibold border border-slate-100">
                        Hele Trekantsområdet
                      </span>
                    </div>
                  </div>

                  {/* Section 7: Skal vi hjælpe dig med at vælge garageport */}
                  <div className="p-6 md:p-8 rounded-2xl bg-gradient-to-r from-brand-dark to-slate-900 text-white flex flex-col gap-4 shadow-md">
                    <h3 className="text-xl md:text-2xl font-bold font-display text-white flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/20 text-brand-accent-light text-sm">
                        <i className="fa-regular fa-comments" />
                      </span>
                      Skal vi hjælpe dig med at vælge garageport?
                    </h3>
                    <p className="text-slate-300 leading-relaxed text-sm md:text-base">
                      Fortæl os, hvordan garagen bruges, og hvad du ønsker af den nye port. Så kan vi drøfte mål, isolering, farve, automatik og eventuel gangadgang. Kontakt Pabst Teknik for faglig rådgivning og et uforpligtende tilbud på garageporte til private.
                    </p>
                    <div className="flex flex-wrap gap-4 pt-2">
                      <Link
                        to="/kontakt"
                        className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-brand-accent text-white font-bold text-sm hover:bg-brand-accent-hover transition-colors shadow-sm"
                      >
                        <span>Kontakt os for uforpligtende tilbud</span>
                        <i className="fa-regular fa-arrow-right text-xs" />
                      </Link>
                      <Link
                        to="/ydelser/garageporte-og-tilbehoer"
                        className="inline-flex items-center gap-2 px-5 py-3.5 rounded-xl bg-white/10 text-white font-semibold text-sm hover:bg-white/20 transition-colors"
                      >
                        <i className="fa-regular fa-gears text-brand-accent" />
                        <span>Se garageport-tilbehør</span>
                      </Link>
                    </div>
                  </div>

                  {/* Section 8: FAQ om garageporte */}
                  <FAQSection
                    title="Ofte stillede spørgsmål om garageporte"
                    subtitle="Få svar på de mest gængse spørgsmål om isolering, sikkerhed, betjening og montage."
                    badge="FAQ"
                    items={GARAGEPORTE_FAQ}
                  />
                </div>
              ) : service.service_slug === 'industriporte' ? (
                <div className="flex flex-col gap-10 text-slate-700">
                  {/* Hero Intro Card */}
                  <div className="rounded-2xl bg-slate-50 border border-slate-100 p-6 md:p-8 flex flex-col gap-4">
                    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent">
                      <i className="fa-solid fa-industry" />
                      <span>Industriporte til erhverv</span>
                    </div>
                    <h2 className="text-2xl md:text-3xl font-extrabold text-brand-dark font-display">
                      Industriporte til erhverv, der passer til jeres drift
                    </h2>
                    <p className="text-base text-slate-600 leading-relaxed">
                      En industriport skal passe til bygningen, trafikken og de krav, som hverdagen stiller. Hos <Link to="/" className="text-brand-dark font-semibold hover:text-brand-accent transition-colors underline decoration-brand-accent/40 decoration-2 underline-offset-2">Pabst Teknik</Link> hjælper vi med rådgivning, montage, service og reparation af industriporte til erhverv. Vi tager udgangspunkt i driften, så I får en løsning, der er praktisk, sikker og egnet til den konkrete bygning.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-2">
                      <div className="flex items-center gap-2 text-xs font-semibold text-slate-700 bg-white p-3 rounded-xl border border-slate-100 shadow-2xs">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Faglig rådgivning</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs font-semibold text-slate-700 bg-white p-3 rounded-xl border border-slate-100 shadow-2xs">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Professionel montage</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs font-semibold text-slate-700 bg-white p-3 rounded-xl border border-slate-100 shadow-2xs">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Løbende service & rep.</span>
                      </div>
                    </div>
                  </div>

                  {/* Section 1: Hvilken industriport gør hverdagen mere effektiv? */}
                  <div className="flex flex-col gap-5">
                    <h3 className="text-xl md:text-2xl font-bold text-brand-dark font-display flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent text-sm">
                        <i className="fa-regular fa-industry" />
                      </span>
                      Hvilken industriport gør hverdagen mere effektiv?
                    </h3>
                    <div className="space-y-4 text-slate-600 leading-relaxed text-sm md:text-base">
                      <p>
                        Valget afhænger blandt andet af portåbningens mål, trafikmængden, temperaturen i bygningen og den ønskede betjening. En port i en opvarmet hal bør begrænse varmetab og kondens, mens en port ved et travlt vareflow skal understøtte hurtig og enkel passage uden at gå på kompromis med sikkerheden.
                      </p>
                      <p>
                        Vi leverer industriporte med robuste overflader i stål eller aluminium, mulighed for isolering og elementer, der giver naturligt lysindfald. Til særlige driftsmiljøer tilbyder vi også hurtigporte, frostporte og frostdøre. Løsningen bliver valgt efter funktion, omgivelser og den daglige belastning.
                      </p>
                    </div>

                    {/* 4 Feature highlight cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs hover:border-brand-accent/30 transition-all flex flex-col justify-between gap-3 group">
                        <div>
                          <div className="flex items-start justify-between gap-2 mb-2">
                            <div className="flex items-center gap-2.5 text-brand-dark font-bold text-base">
                              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                                <i className="fa-solid fa-warehouse" />
                              </span>
                              <h4>Isolerede industriporte</h4>
                            </div>
                            <span className="text-[10px] font-bold px-2 py-0.5 rounded-md bg-brand-accent/10 text-brand-accent border border-brand-accent/20 shrink-0">
                              46 mm Termo
                            </span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Til opvarmede produktionshaller og lagerbygninger, hvor minimalt varmetab og tæthed mod træk og kulde er afgørende for energiregnskabet.
                          </p>
                        </div>
                        <div className="flex items-center gap-2 pt-2 border-t border-slate-100 text-[11px] font-semibold text-slate-600">
                          <i className="fa-solid fa-circle-check text-brand-accent" />
                          <span>Effektiv mod varmetab og kondens</span>
                        </div>
                      </div>

                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs hover:border-brand-accent/30 transition-all flex flex-col justify-between gap-3 group">
                        <div>
                          <div className="flex items-start justify-between gap-2 mb-2">
                            <div className="flex items-center gap-2.5 text-brand-dark font-bold text-base">
                              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                                <i className="fa-solid fa-sun-bright" />
                              </span>
                              <h4>Elementer med lysindfald</h4>
                            </div>
                            <span className="text-[10px] font-bold px-2 py-0.5 rounded-md bg-sky-50 text-brand-accent border border-sky-100 shrink-0">
                              Fuldsynspaneler
                            </span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Elementer med lysindfald, når dagslys er vigtigt i arbejdsområdet for at skabe et lyst arbejdsmiljø og sikkert overblik ved portpassagen.
                          </p>
                        </div>
                        <div className="flex items-center gap-2 pt-2 border-t border-slate-100 text-[11px] font-semibold text-slate-600">
                          <i className="fa-solid fa-circle-check text-brand-accent" />
                          <span>Slagfaste ruder & optimalt dagslys</span>
                        </div>
                      </div>

                      <Link
                        to="/ydelser/portservice-automatik"
                        className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs hover:border-brand-accent/30 transition-all flex flex-col justify-between gap-3 group"
                      >
                        <div>
                          <div className="flex items-start justify-between gap-2 mb-2">
                            <div className="flex items-center gap-2.5 text-brand-dark font-bold text-base">
                              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm group-hover:bg-brand-accent group-hover:text-white transition-colors">
                                <i className="fa-solid fa-bolt-lightning" />
                              </span>
                              <h4 className="text-brand-dark group-hover:text-brand-accent transition-colors">Hurtigporte</h4>
                            </div>
                            <span className="text-[10px] font-bold px-2 py-0.5 rounded-md bg-brand-accent/10 text-brand-accent border border-brand-accent/20 shrink-0">
                              Hurtig passage
                            </span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Hurtigporte til områder med hyppig intern trafik og behov for hurtig passage, så truckkørsel forløber ubesværet og uden trækgener.
                          </p>
                        </div>
                        <div className="flex items-center justify-between pt-2 border-t border-slate-100 text-[11px] font-semibold text-brand-accent">
                          <span className="flex items-center gap-2">
                            <i className="fa-solid fa-gauge-max text-brand-accent" />
                            Lynhurtig åbning & lukning
                          </span>
                          <span className="underline decoration-dotted">Læs mere →</span>
                        </div>
                      </Link>

                      <Link
                        to="/ydelser/indbrudssikring"
                        className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs hover:border-brand-accent/30 transition-all flex flex-col justify-between gap-3 group"
                      >
                        <div>
                          <div className="flex items-start justify-between gap-2 mb-2">
                            <div className="flex items-center gap-2.5 text-brand-dark font-bold text-base">
                              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm group-hover:bg-brand-accent group-hover:text-white transition-colors">
                                <i className="fa-solid fa-snowflake" />
                              </span>
                              <h4 className="text-brand-dark group-hover:text-brand-accent transition-colors">Frostporte og frostdøre</h4>
                            </div>
                            <span className="text-[10px] font-bold px-2 py-0.5 rounded-md bg-sky-50 text-brand-accent border border-sky-100 shrink-0">
                              Temperaturstyret
                            </span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Frostporte og frostdøre til kølelagre, fryserum og temperaturstyrede områder med ekstra tæthed og isolering mod kuldebroer.
                          </p>
                        </div>
                        <div className="flex items-center justify-between pt-2 border-t border-slate-100 text-[11px] font-semibold text-brand-accent">
                          <span className="flex items-center gap-2">
                            <i className="fa-solid fa-snowflake text-brand-accent" />
                            Køle- & fryseløsninger
                          </span>
                          <span className="underline decoration-dotted">Læs mere →</span>
                        </div>
                      </Link>
                    </div>
                  </div>

                  {/* Section 2 & 3: Tilpasning og Indeklima */}
                  <div className="flex flex-col gap-6">
                    {/* Card 1: Vælg port efter bygning, trafik og indeklima */}
                    <div className="rounded-2xl bg-gradient-to-br from-slate-50 to-sky-50/40 border border-slate-100 p-6 md:p-8 flex flex-col gap-6">
                      <div className="flex flex-col gap-3">
                        <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent">
                          <i className="fa-regular fa-sliders" />
                          <span>Tilpasning & Drift</span>
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold font-display text-brand-dark">
                          Vælg port efter bygning, trafik og indeklima
                        </h3>
                        <p className="text-sm md:text-base text-slate-600 leading-relaxed max-w-4xl">
                          To bygninger kan have samme portmål og alligevel kræve forskellige løsninger. Vindforhold, plads ved loft og sider, antal åbninger og behovet for adgang har betydning for både porttype og automatik. Derfor rådgiver vi ud fra den konkrete anvendelse frem for at anbefale en standardløsning til alle.
                        </p>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 pt-4 border-t border-slate-200/60">
                        <div className="flex items-start gap-2.5 p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs">
                          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                            <i className="fa-solid fa-wind" />
                          </span>
                          <div>
                            <h4 className="text-xs font-bold text-brand-dark">Vindforhold</h4>
                            <p className="text-[11px] text-slate-500">Udsatte facader & vindlast</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-2.5 p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs">
                          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                            <i className="fa-solid fa-ruler-combined" />
                          </span>
                          <div>
                            <h4 className="text-xs font-bold text-brand-dark">Pladsforhold</h4>
                            <p className="text-[11px] text-slate-500">Loftshøjde & skinner</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-2.5 p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs">
                          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                            <i className="fa-solid fa-arrows-repeat" />
                          </span>
                          <div>
                            <h4 className="text-xs font-bold text-brand-dark">Trafikmængde</h4>
                            <p className="text-[11px] text-slate-500">Daglige åbninger & flow</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-2.5 p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs">
                          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                            <i className="fa-solid fa-shield-check" />
                          </span>
                          <div>
                            <h4 className="text-xs font-bold text-brand-dark">Adgang & automatik</h4>
                            <p className="text-[11px] text-slate-500">Styring & sikkerhed</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Card 2: Hvor meget betyder isolering og lysindfald? */}
                    <div className="rounded-2xl bg-gradient-to-br from-slate-50 to-sky-50/40 border border-slate-100 p-6 md:p-8 flex flex-col gap-6">
                      <div className="flex flex-col gap-3">
                        <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent">
                          <i className="fa-regular fa-temperature-sun" />
                          <span>Indeklima & Energi</span>
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold font-display text-brand-dark">
                          Hvor meget betyder isolering og lysindfald?
                        </h3>
                        <div className="space-y-3 text-sm md:text-base text-slate-600 leading-relaxed max-w-4xl">
                          <p>
                            I produktionshaller og lagerbygninger kan en isolerende konstruktion bidrage til et mere stabilt indeklima. Industriportene kan blandt andet leveres med <strong className="text-slate-800 font-semibold">46 mm tykke elementer</strong>. Hvis arbejdsområdet har brug for dagslys, kan porten tilpasses med sektioner, der skaber lysindfald i bygningen.
                          </p>
                          <p>
                            Isolering skal altid ses i sammenhæng med portens tæthed, åbne tid og den trafik, der passerer gennem åbningen. Vi hjælper med at afveje komfort, drift og funktion, så I ikke vælger mere eller mindre port end nødvendigt. Målet er en løsning, som giver mening i den daglige anvendelse.
                          </p>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 border-t border-slate-200/60 max-w-2xl">
                        <div className="p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs flex items-center gap-3">
                          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                            <i className="fa-solid fa-layer-group" />
                          </span>
                          <div>
                            <div className="text-sm font-bold text-brand-dark">46 mm isolering</div>
                            <div className="text-xs text-slate-500">Mindre varmetab & kondens</div>
                          </div>
                        </div>

                        <div className="p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs flex items-center gap-3">
                          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-brand-accent text-sm">
                            <i className="fa-solid fa-sun-bright" />
                          </span>
                          <div>
                            <div className="text-sm font-bold text-brand-dark">Naturligt lysindfald</div>
                            <div className="text-xs text-slate-500">Bedre arbejdsmiljø i hallen</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Section 4: Få montage og automatik tænkt sammen fra start */}
                  <div className="flex flex-col gap-5">
                    <h3 className="text-xl md:text-2xl font-bold text-brand-dark font-display flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-accent/10 text-brand-accent text-sm">
                        <i className="fa-regular fa-gears" />
                      </span>
                      Få montage og automatik tænkt sammen fra start
                    </h3>
                    <div className="space-y-4 text-slate-600 leading-relaxed text-sm md:text-base">
                      <p>
                        En god industriport afhænger ikke kun af selve portbladet. Montage, styring og sikkerhedsfunktioner skal fungere sammen fra første dag. Vi monterer nye porte og kan kombinere dem med passende automatik, så åbning og lukning passer til arbejdsgangen, bygningen og den valgte adgangsform.
                      </p>
                      <p>
                        Ved en ny løsning ser vi på mål, pladsforhold og de praktiske behov omkring portåbningen. Det giver et bedre grundlag for at vælge materialer, betjening og tilbehør. Efter montagen er vi også klar til løbende service, reparation og eftersyn, så porten kan følges gennem hele dens levetid.
                      </p>
                    </div>

                    {/* 4 Feature cards */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-2">
                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col justify-between gap-3">
                        <div>
                          <div className="flex items-center gap-2 text-brand-dark font-bold text-sm mb-1.5">
                            <i className="fa-solid fa-wrench text-brand-accent" />
                            <span>Montage & automatik</span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Montage af ny port og tilpasset portautomatik afstemt med bygningens fysiske rammer og adgangskrav.
                          </p>
                        </div>
                        <div className="pt-2 border-t border-slate-100 text-[11px] text-brand-accent font-semibold flex items-center gap-1.5">
                          <i className="fa-solid fa-circle-check text-brand-accent" />
                          <span>Tilpasset drift</span>
                        </div>
                      </div>

                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col justify-between gap-3">
                        <div>
                          <div className="flex items-center gap-2 text-brand-dark font-bold text-sm mb-1.5">
                            <i className="fa-solid fa-screwdriver-wrench text-brand-accent" />
                            <span>Løbende service</span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Service og vedligeholdelse af forskellige fabrikater for at sikre lang levetid og forebygge uventede stop.
                          </p>
                        </div>
                        <div className="pt-2 border-t border-slate-100 text-[11px] text-brand-accent font-semibold flex items-center gap-1.5">
                          <i className="fa-solid fa-circle-check text-brand-accent" />
                          <span>Alle fabrikater</span>
                        </div>
                      </div>

                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col justify-between gap-3">
                        <div>
                          <div className="flex items-center gap-2 text-brand-dark font-bold text-sm mb-1.5">
                            <i className="fa-solid fa-truck-fast text-brand-accent" />
                            <span>Reparation ved slid</span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Reparation ved slid, fejl eller skade på porten med hurtig lokal udrykning og reservedele.
                          </p>
                        </div>
                        <div className="pt-2 border-t border-slate-100 text-[11px] text-brand-accent font-semibold flex items-center gap-1.5">
                          <i className="fa-solid fa-circle-check text-brand-accent" />
                          <span>Hurtig udrykning</span>
                        </div>
                      </div>

                      <div className="p-5 rounded-2xl bg-white border border-slate-100 shadow-2xs flex flex-col justify-between gap-3">
                        <div>
                          <div className="flex items-center gap-2 text-brand-dark font-bold text-sm mb-1.5">
                            <i className="fa-solid fa-clipboard-check text-brand-accent" />
                            <span>Lovpligtigt eftersyn</span>
                          </div>
                          <p className="text-xs text-slate-500 leading-relaxed">
                            Lovpligtigt porteftersyn og mulighed for en fast serviceaftale med fuld dokumentation og servicebog.
                          </p>
                        </div>
                        <div className="pt-2 border-t border-slate-100 text-[11px] text-brand-accent font-semibold flex items-center gap-1.5">
                          <i className="fa-solid fa-circle-check text-brand-accent" />
                          <span>Fuld dokumentation</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Section 5: Hold industriporten sikker og funktionsdygtig */}
                  <div className="p-6 md:p-8 rounded-3xl bg-slate-900 text-white shadow-lg relative overflow-hidden flex flex-col gap-5">
                    <div className="absolute top-0 right-0 -mt-8 -mr-8 w-40 h-40 bg-brand-accent/20 rounded-full blur-2xl pointer-events-none" />
                    
                    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent-light">
                      <i className="fa-regular fa-shield-check" />
                      <span>Sikkerhed & Lovkrav</span>
                    </div>

                    <h3 className="text-xl md:text-2xl font-bold font-display text-white">
                      Hold industriporten sikker og funktionsdygtig
                    </h3>

                    <div className="space-y-4 text-slate-300 leading-relaxed text-sm md:text-base">
                      <p>
                        En industriport er en bevægelig del af bygningen og bliver ofte brugt mange gange i løbet af en arbejdsdag. Regelmæssig portservice kan opdage slid og begyndende fejl, før de udvikler sig til større problemer. Vi servicerer forskellige fabrikater og udfører reparation, når porten ikke fungerer som den skal.
                      </p>
                      <p>
                        Vi tilbyder også <strong>lovpligtigt porteftersyn på erhvervsejendomme</strong> og rådgiver om de krav, der er relevante for den konkrete port. Med en fast serviceaftale kan vi hjælpe med at holde styr på næste eftersyn og den løbende vedligeholdelse. Det giver jer et mere overskueligt grundlag for sikker drift.
                      </p>
                    </div>

                    <div className="pt-2 flex flex-wrap items-center gap-4">
                      <Link
                        to="/ydelser/portservice-og-lovpligtigt-eftersyn"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-brand-accent text-white font-bold text-sm hover:bg-brand-accent-hover transition-colors shadow-md"
                      >
                        <span>Læs om lovpligtigt eftersyn</span>
                        <i className="fa-regular fa-arrow-right text-xs" />
                      </Link>
                      <Link
                        to="/kontakt"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-white/10 text-white font-semibold text-sm hover:bg-white/20 transition-colors"
                      >
                        <i className="fa-regular fa-calendar-check text-brand-accent" />
                        <span>Tegn serviceaftale</span>
                      </Link>
                    </div>
                  </div>

                  {/* Section 6: Få et tilbud på industriporte med lokal rådgivning */}
                  <div className="flex flex-col gap-4 p-6 md:p-7 rounded-2xl bg-gradient-to-br from-slate-50 to-sky-50/40 border border-slate-100">
                    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent">
                      <i className="fa-regular fa-scale-balanced" />
                      <span>Rådgivning & Tilbud</span>
                    </div>

                    <h3 className="text-xl md:text-2xl font-bold font-display text-brand-dark">
                      Få et tilbud på industriporte med lokal rådgivning
                    </h3>

                    <div className="space-y-4 text-slate-600 leading-relaxed text-sm md:text-base">
                      <p>
                        Pabst Teknik har base i Vejen og hjælper virksomheder i blandt andet Kolding, Christiansfeld, Fredericia, Vejle, Billund og resten af Trekantsområdet. Den lokale placering gør det naturligt at kombinere rådgivning og montage med efterfølgende portservice, hvis I ønsker én samarbejdspartner til opgaven.
                      </p>
                      <p>
                        Der findes leverandører af industriporte Danmark over. Når I søger på <em>industriporte tilbud</em>, er pris kun ét punkt i beslutningen. Se også på tilpasning, montage, automatik og mulighederne for efterfølgende service. Søger du i stedet en stilren port til privaten, rådgiver og monterer vi også skræddersyede <Link to="/ydelser/garageporte" className="text-brand-dark font-semibold hover:text-brand-accent transition-colors underline decoration-brand-accent/40 decoration-2 underline-offset-2">garageporte</Link> til boligejere. Kontakt os, så vi kan tale om jeres port og udarbejde et uforpligtende tilbud.
                      </p>
                    </div>

                    {/* 4 Checklist items */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 pt-2">
                      <div className="p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs text-xs text-slate-700 font-semibold flex items-center gap-2.5">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Pris & totaløkonomi</span>
                      </div>
                      <div className="p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs text-xs text-slate-700 font-semibold flex items-center gap-2.5">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Mål & tilpasning</span>
                      </div>
                      <div className="p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs text-xs text-slate-700 font-semibold flex items-center gap-2.5">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Automatik & styring</span>
                      </div>
                      <div className="p-3.5 rounded-xl bg-white border border-slate-100 shadow-2xs text-xs text-slate-700 font-semibold flex items-center gap-2.5">
                        <i className="fa-solid fa-circle-check text-brand-accent" />
                        <span>Lokal service</span>
                      </div>
                    </div>

                    <div className="pt-2 flex flex-wrap items-center gap-4">
                      <Link
                        to="/kontakt"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-brand-accent text-white font-bold text-sm hover:bg-brand-accent-hover transition-colors shadow-md"
                      >
                        <span>Få et uforpligtende tilbud</span>
                        <i className="fa-regular fa-arrow-right text-xs" />
                      </Link>
                      <a
                        href="tel:+4521684422"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-white border border-slate-200 text-brand-dark font-semibold text-sm hover:bg-slate-50 transition-colors"
                      >
                        <i className="fa-regular fa-phone text-brand-accent" />
                        <span>Ring 21 68 44 22</span>
                      </a>
                    </div>
                  </div>

                  {/* Section 7: Dækningsområde */}
                  <div className="rounded-2xl bg-white border border-slate-100 p-6 md:p-8 shadow-2xs flex flex-col gap-4">
                    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent">
                      <i className="fa-regular fa-map-location-dot" />
                      <span>Dækningsområde</span>
                    </div>

                    <h3 className="text-xl md:text-2xl font-bold font-display text-brand-dark">
                      Lokal forankring og stærkt fokus på Trekantsområdet
                    </h3>

                    <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                      Med base i Vejen har vi vores primære fokus på erhvervskunder i hele Trekantsområdet – herunder Kolding, Christiansfeld, Fredericia, Vejle, Billund, Middelfart og det omkringliggende opland. Vores montører kører dagligt i området med veludstyrede servicevogne, hvilket sikrer hurtig responstid ved både planlagte montager, lovpligtige porteftersyn og akutte driftsstop.
                    </p>

                    {/* Corridor Badges */}
                    <div className="flex flex-wrap gap-2 pt-2">
                      <span className="px-3 py-1.5 rounded-lg bg-sky-50 text-brand-accent border border-sky-100 text-xs font-bold flex items-center gap-1.5">
                        <i className="fa-solid fa-building" />
                        Vejen (Base)
                      </span>
                      <span className="px-3 py-1.5 rounded-lg bg-slate-50 text-slate-700 border border-slate-100 text-xs font-medium">
                        Kolding
                      </span>
                      <span className="px-3 py-1.5 rounded-lg bg-slate-50 text-slate-700 border border-slate-100 text-xs font-medium">
                        Christiansfeld
                      </span>
                      <span className="px-3 py-1.5 rounded-lg bg-slate-50 text-slate-700 border border-slate-100 text-xs font-medium">
                        Fredericia
                      </span>
                      <span className="px-3 py-1.5 rounded-lg bg-slate-50 text-slate-700 border border-slate-100 text-xs font-medium">
                        Vejle
                      </span>
                      <span className="px-3 py-1.5 rounded-lg bg-slate-50 text-slate-700 border border-slate-100 text-xs font-medium">
                        Billund
                      </span>
                      <span className="px-3 py-1.5 rounded-lg bg-slate-50 text-slate-700 border border-slate-100 text-xs font-medium">
                        Middelfart
                      </span>
                      <span className="px-3 py-1.5 rounded-lg bg-slate-50 text-slate-700 border border-slate-100 text-xs font-medium">
                        Hele Trekantsområdet
                      </span>
                    </div>
                  </div>

                  {/* Section 8: Dialog om industriporte */}
                  <div className="rounded-2xl bg-gradient-to-br from-slate-50 to-sky-50/40 border border-slate-100 p-6 md:p-8 flex flex-col gap-4">
                    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-accent">
                      <i className="fa-regular fa-comments" />
                      <span>Faglig Dialog</span>
                    </div>
                    <h3 className="text-xl md:text-2xl font-bold font-display text-brand-dark">
                      Skal vi hjælpe jeres virksomhed med en industriport?
                    </h3>
                    <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                      Fortæl os om jeres bygning, trafikmønster og krav til isolering og hastighed. Vi rådgiver gerne om den mest optimale løsning til jeres drift og fremsender et uforpligtende tilbud.
                    </p>
                    <div className="flex flex-wrap items-center gap-3 pt-2">
                      <Link
                        to="/kontakt"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-brand-accent text-white font-bold text-sm hover:bg-brand-accent-hover transition-colors shadow-md"
                      >
                        <span>Kontakt os for uforpligtende tilbud</span>
                        <i className="fa-regular fa-arrow-right text-xs" />
                      </Link>
                      <a
                        href="tel:+4521684422"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-white border border-slate-200 text-brand-dark font-semibold text-sm hover:bg-slate-50 transition-colors"
                      >
                        <i className="fa-regular fa-phone text-brand-accent" />
                        <span>Ring 21 68 44 22</span>
                      </a>
                    </div>
                  </div>

                  {/* Section 9: FAQ om industriporte */}
                  <FAQSection
                    title="Ofte stillede spørgsmål om industriporte"
                    subtitle="Få svar på spørgsmål om lovpligtigt eftersyn, isolering, styring og akut portservice."
                    badge="FAQ"
                    items={INDUSTRIPORTE_FAQ}
                  />
                </div>
              ) : (
                <div
                  className="prose max-w-none break-words"
                  dangerouslySetInnerHTML={{ __html: formatDescriptionWithFrontpageLink(service.description.da) }}
                />
              )}

              {/* Video Integration */}
              {service.service_slug === 'alarmsystem-forebyggelse-af-vandlaekage' && (
                <div className="mt-8 pt-8 border-t border-slate-100 flex flex-col gap-4">
                  <h3 className="font-display text-xl font-bold text-brand-dark flex items-center gap-2">
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent">
                      <i className="fa-regular fa-circle-play" />
                    </span>
                    Se Ajax WaterStop i aktion
                  </h3>
                  <p className="text-sm text-slate-600">
                    Se hvordan den fjernstyrede elektriske ventil lukker for vandet på få sekunder og forhindrer dyre vandskader.
                  </p>
                  <div className="relative overflow-hidden rounded-2xl border border-slate-100 shadow-lg aspect-[16/9] bg-slate-950 group">
                    <iframe
                      src="https://www.youtube.com/embed/a8jo0k222Qk"
                      title="Ajax WaterStop: remotely controlled water shutoff electric valve"
                      className="absolute inset-0 w-full h-full border-0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                  </div>
                </div>
              )}

              {/* Branddetektion Video Integration */}
              {service.service_slug === 'alarmsystem-branddetektion' && (
                <div className="mt-8 pt-8 border-t border-slate-100 flex flex-col gap-8">
                  <div className="flex flex-col gap-4">
                    <h3 className="font-display text-xl font-bold text-brand-dark flex items-center gap-2">
                      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent">
                        <i className="fa-regular fa-circle-play" />
                      </span>
                      Se Ajax FireProtect 2 i aktion
                    </h3>
                    <p className="text-sm text-slate-600">
                      Hør mere om den næste generations branddetektor, der skelner røg fra damp og minimerer falske alarmer.
                    </p>
                    <div className="relative overflow-hidden rounded-2xl border border-slate-100 shadow-lg aspect-[16/9] bg-slate-950 group">
                      <iframe
                        src="https://www.youtube.com/embed/-wVQDdkJBfc"
                        title="Ajax FireProtect 2: accurate fire detector through interferences"
                        className="absolute inset-0 w-full h-full border-0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-4">
                    <h3 className="font-display text-xl font-bold text-brand-dark flex items-center gap-2">
                      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent">
                        <i className="fa-regular fa-circle-play" />
                      </span>
                      Ajax Special Event: Rule your space
                    </h3>
                    <p className="text-sm text-slate-600">
                      Oplev hvordan Ajax' innovative funktioner følger en alarm på få sekunder, deaktiverer anlægget, tænder nødlys og låser udgange op.
                    </p>
                    <div className="relative overflow-hidden rounded-2xl border border-slate-100 shadow-lg aspect-[16/9] bg-slate-950 group">
                      <iframe
                        src="https://www.youtube.com/embed/J86Phwb_9lw"
                        title="Ajax Special Event: Rule your space"
                        className="absolute inset-0 w-full h-full border-0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Ramper og Sluser Custom Section */}
              {service.service_slug === 'ramper-og-sluser' && (
                <div className="mt-12 pt-12 border-t border-slate-100 flex flex-col gap-12">
                  <div className="flex flex-col gap-4">
                    <h3 className="font-display text-2xl font-bold text-brand-dark flex items-center gap-2">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent">
                        <i className="fa-regular fa-truck-ramp" />
                      </span>
                      Professionelle Rampe- & Sluseløsninger
                    </h3>
                    <p className="text-sm text-slate-600 max-w-2xl">
                      Vi leverer, monterer og servicerer komplette læsseramper og slusesystemer, der optimerer logistikken, forbedrer arbejdsmiljøet og reducerer energiforbruget.
                    </p>
                  </div>

                  {/* Split Grid for Ramper and Sluser */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Ramper Card */}
                    <div className="group flex flex-col rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-brand-accent/30 transition-all duration-300">
                      <div className="aspect-[16/10] overflow-hidden bg-slate-50 relative">
                        <img 
                          src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-20200922-1456141392-rotated-17-11zon-600x400.webp?cdn-cgi/image/width=600,quality=85,format=auto" 
                          alt="Lindab hydraulisk læsserampe monteret til stabil overgang og godshåndtering" 
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6 flex flex-col gap-4 flex-1">
                        <h4 className="font-display text-lg font-bold text-brand-dark flex items-center gap-2 group-hover:text-brand-accent transition-colors">
                          <i className="fa-regular fa-truck-ramp text-brand-accent" /> Hydrauliske Læsseramper
                        </h4>
                        <p className="text-sm text-slate-600 leading-relaxed flex-1">
                          Effektiv af- og pålæsning af gods på køretøjer er en vigtig parameter i moderne logistiksystemer. Læsseramper betjenes af en hydraulisk cylinder, der sikrer en stabil overgang mellem bygning og køretøj. Lindab læsseramper er udformet således, at der er mindst muligt slid på udstyr til godshåndteringen samt bedre arbejdsmiljø for medarbejderne.
                        </p>
                        <div className="pt-4 border-t border-slate-50 flex flex-col gap-2">
                          <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
                            <i className="fa-solid fa-circle-check text-brand-accent text-[10px]" />
                            <span>Stabilt og sikkert arbejdsmiljø</span>
                          </div>
                          <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
                            <i className="fa-solid fa-circle-check text-brand-accent text-[10px]" />
                            <span>Moderne og slidstærkt design</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Sluser Card */}
                    <div className="group flex flex-col rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-brand-accent/30 transition-all duration-300">
                      <div className="aspect-[16/10] overflow-hidden bg-slate-50 relative">
                        <img 
                          src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-fb-img-1642448351158-1-61-11zon-600x400.webp?cdn-cgi/image/width=600,quality=85,format=auto" 
                          alt="Lindab isolerende slusesystem for optimal klimakontrol og trækbeskyttelse" 
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6 flex flex-col gap-4 flex-1">
                        <h4 className="font-display text-lg font-bold text-brand-dark flex items-center gap-2 group-hover:text-brand-accent transition-colors">
                          <i className="fa-regular fa-warehouse text-brand-accent" /> Isolerende Slusesystemer
                        </h4>
                        <p className="text-sm text-slate-600 leading-relaxed flex-1">
                          Pabst Teknik tilbyder at hjælpe med sluser, som giver optimal beskyttelse mod vejrlig ved af- og pålæsning af gods. Den giver optimal klimakontrol i bygningen, hvorved energiomkostningerne nedbringes, og samtidig beskyttes personalet mod træk. Slusen er designet med en kollisionssikker ramme uden fjederpåvirkning, således at en eventuel påkørsel ikke beskadiger slusen.
                        </p>
                        <div className="pt-4 border-t border-slate-50 flex flex-col gap-2">
                          <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
                            <i className="fa-solid fa-circle-check text-brand-accent text-[10px]" />
                            <span>Optimal beskyttelse mod træk og kulde</span>
                          </div>
                          <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
                            <i className="fa-solid fa-circle-check text-brand-accent text-[10px]" />
                            <span>Kollisionssikker ramme uden fjedre</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Garageporte og tilbehør Accessories Section */}
              {service.service_slug === 'garageporte-og-tilbehoer' && (
                <div className="mt-12 pt-12 border-t border-slate-100 flex flex-col gap-8">
                  {/* Lindab Partner Badge */}
                  <div className="flex flex-col sm:flex-row items-center gap-6 p-6 rounded-2xl bg-slate-50 border border-slate-100">
                    <div className="w-40 shrink-0 bg-white p-4 rounded-xl border border-slate-100 flex items-center justify-center shadow-sm">
                      <img 
                        src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/124874-logo-lindab-11zon-1-300x92.webp" 
                        alt="Lindab autoriseret portpartner logo hos Pabst Teknik ApS" 
                        className="max-h-12 object-contain"
                      />
                    </div>
                    <div className="flex flex-col gap-1 text-center sm:text-left">
                      <span className="text-xs font-bold uppercase tracking-wider text-brand-accent">Autoriseret Forhandler</span>
                      <h4 className="font-display text-lg font-bold text-brand-dark">Professionel montage af Lindab portsystemer</h4>
                      <p className="text-sm text-slate-600">
                        Vi leverer, monterer og servicerer originale Lindab garageporte og tilbehør i Vejen og omegn med fokus på højeste kvalitet og sikkerhed.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col gap-4">
                    <h3 className="font-display text-2xl font-bold text-brand-dark flex items-center gap-2">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent">
                        <i className="fa-regular fa-gears" />
                      </span>
                      Tilbehør & Opgraderinger
                    </h3>
                    <p className="text-sm text-slate-600 max-w-2xl">
                      Gør din hverdag nemmere og mere sikker med det rette ekstraudstyr til din Lindab garageport. Vi hjælper dig med rådgivning og professionel installation.
                    </p>
                  </div>

                  {/* Accessories Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* El-betjening */}
                    <div className="group flex flex-col rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-brand-accent/30 transition-all duration-300">
                      <div className="aspect-[16/10] overflow-hidden bg-slate-50 relative">
                        <img 
                          src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-highend-elbetjeninger-65-11zon.webp?cdn-cgi/image/width=600,quality=80,format=auto" 
                          alt="Lindab High-End el-betjening og motorautomatik til garageporte med soft start og stop" 
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <span className="absolute top-3 right-3 bg-brand-accent text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-sm">
                          Mest Populær
                        </span>
                      </div>
                      <div className="p-6 flex flex-col gap-3 flex-1">
                        <h4 className="font-display text-lg font-bold text-brand-dark flex items-center gap-2 group-hover:text-brand-accent transition-colors">
                          <i className="fa-regular fa-bolt text-brand-accent" /> El-betjening
                        </h4>
                        <p className="text-sm text-slate-600 leading-relaxed flex-1">
                          Sikker løsning med høj brugerkomfort. Betjen porten nemt inde fra bilen, så du slipper for dårligt vejr. Strømbesparende med "soft start/stop", LED-belysning, kraftovervågning og indbygget indbrudssikring.
                        </p>
                        <div className="pt-3 border-t border-slate-50 flex flex-wrap gap-2">
                          <span className="text-[11px] font-semibold bg-slate-100 text-slate-600 px-2.5 py-0.5 rounded-md">Tüv Testet</span>
                          <span className="text-[11px] font-semibold bg-slate-100 text-slate-600 px-2.5 py-0.5 rounded-md">Indbrudssikret</span>
                        </div>
                      </div>
                    </div>

                    {/* Minifjernbetjening */}
                    <div className="group flex flex-col rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-brand-accent/30 transition-all duration-300">
                      <div className="aspect-[16/10] overflow-hidden bg-slate-50">
                        <img 
                          src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-fjernbetjeninger-62-11zon.webp?cdn-cgi/image/width=600,quality=80,format=auto" 
                          alt="Trådløs 4-kanals minifjernbetjening 868 MHz til betjening af op til 4 porte" 
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6 flex flex-col gap-3 flex-1">
                        <h4 className="font-display text-lg font-bold text-brand-dark flex items-center gap-2 group-hover:text-brand-accent transition-colors">
                          <i className="fa-regular fa-signal text-brand-accent" /> Minifjernbetjening
                        </h4>
                        <p className="text-sm text-slate-600 leading-relaxed flex-1">
                          Få en ekstra fjernbetjening med 4 kanaler, der kan betjene op til 4 porte! Leveres komplet med en praktisk vægholder og clips til montering på solskærmen i bilen.
                        </p>
                        <div className="pt-3 border-t border-slate-50 flex flex-col gap-1.5 text-xs text-slate-500">
                          <div className="flex justify-between"><span>Frekvens:</span> <span className="font-semibold text-slate-700">868 MHz</span></div>
                          <div className="flex justify-between"><span>Tæthedsklasse:</span> <span className="font-semibold text-slate-700">IP54</span></div>
                          <div className="flex justify-between"><span>Størrelse:</span> <span className="font-semibold text-slate-700">39 x 92 x 12 mm</span></div>
                        </div>
                      </div>
                    </div>

                    {/* Trådløst kodetastatur */}
                    <div className="group flex flex-col rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-brand-accent/30 transition-all duration-300">
                      <div className="aspect-[16/10] overflow-hidden bg-slate-50">
                        <img 
                          src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-fjernbetjeninger-62-11zon.webp?cdn-cgi/image/width=600,quality=80,format=auto" 
                          alt="Lindab Doorline SR robust trådløst kodetastatur til nøglefri portadgang" 
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6 flex flex-col gap-3 flex-1">
                        <h4 className="font-display text-lg font-bold text-brand-dark flex items-center gap-2 group-hover:text-brand-accent transition-colors">
                          <i className="fa-regular fa-keypad text-brand-accent" /> Trådløst Kodetastatur
                        </h4>
                        <p className="text-sm text-slate-600 leading-relaxed flex-1">
                          Lindab Doorline SR trådløst kodetastatur. Perfekt løsning hvis du ønsker adgang uden fjernbetjening eller nøgle. Tastaturet er yderst robust og kan betjene op til 3 porte uafhængigt.
                        </p>
                        <div className="pt-3 border-t border-slate-50 flex flex-col gap-1.5 text-xs text-slate-500">
                          <div className="flex justify-between"><span>Frekvens:</span> <span className="font-semibold text-slate-700">868 MHz</span></div>
                          <div className="flex justify-between"><span>Tæthedsklasse:</span> <span className="font-semibold text-slate-700">IP54</span></div>
                          <div className="flex justify-between"><span>Størrelse:</span> <span className="font-semibold text-slate-700">80 x 102 x 35 mm</span></div>
                        </div>
                      </div>
                    </div>

                    {/* iSmartgate */}
                    <div className="group flex flex-col rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm hover:shadow-md hover:border-brand-accent/30 transition-all duration-300">
                      <div className="aspect-[16/10] overflow-hidden bg-slate-50">
                        <img 
                          src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-ismartgate-72-11zon.webp?cdn-cgi/image/width=600,quality=80,format=auto" 
                          alt="iSmartgate smart-styring med app-kontrol og integreret overvågningskamera til porte" 
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6 flex flex-col gap-3 flex-1">
                        <h4 className="font-display text-lg font-bold text-brand-dark flex items-center gap-2 group-hover:text-brand-accent transition-colors">
                          <i className="fa-regular fa-mobile-screen-button text-brand-accent" /> iSmartgate Smart-styring
                        </h4>
                        <p className="text-sm text-slate-600 leading-relaxed flex-1">
                          Fjernstyring af op til 3 garageporte direkte fra din smartphone. Inkluderer trådløs sensor til én port samt et indendørs kamera, så du altid kan se, om porten er lukket ordentligt.
                        </p>
                        <div className="pt-3 border-t border-slate-50 flex flex-wrap gap-2">
                          <span className="text-[11px] font-semibold bg-slate-100 text-slate-600 px-2.5 py-0.5 rounded-md">Android & iOS</span>
                          <span className="text-[11px] font-semibold bg-slate-100 text-slate-600 px-2.5 py-0.5 rounded-md">Wi-Fi</span>
                          <span className="text-[11px] font-semibold bg-slate-100 text-slate-600 px-2.5 py-0.5 rounded-md">Inkl. Kamera</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Right Side: Sidebar */}
            <div className="lg:col-span-4 flex flex-col gap-8 lg:sticky lg:top-28">
              {/* Other Services List */}
              <div className="hidden lg:block rounded-2xl border border-slate-100 bg-slate-50 p-6 shadow-sm">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="font-display text-base font-bold text-brand-dark uppercase tracking-wider">
                    Vi tilbyder også
                  </h3>
                  <Link to="/ydelser" className="text-xs font-bold text-brand-accent hover:underline">
                    Se alle
                  </Link>
                </div>
                <div className="flex flex-col gap-3">
                  {otherServices.slice(0, 5).map((s) => (
                    <Link
                      key={s.service_slug}
                      to={`/ydelser/${s.service_slug}`}
                      className="flex items-center gap-3 rounded-xl bg-white border border-slate-100 p-3 text-sm font-semibold text-slate-700 transition-all hover:border-brand-accent hover:text-brand-accent hover:shadow-sm"
                    >
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-accent-light text-brand-accent">
                        <i className={getIconClass(s.icon)} />
                      </span>
                      <span className="truncate">{s.title.da}</span>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Related internal navigation card */}
              <div className="rounded-2xl border border-slate-100 bg-slate-50 p-6 shadow-sm flex flex-col gap-3">
                <h4 className="font-display text-sm font-bold text-brand-dark uppercase tracking-wider">
                  Mere information
                </h4>
                <Link
                  to="/galleri"
                  className="flex items-center justify-between p-3 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm font-semibold text-slate-700 hover:text-brand-accent hover:border-brand-accent transition-all"
                >
                  <span className="flex items-center gap-2.5">
                    <i className="fa-regular fa-images text-brand-accent" />
                    <span>Se fotos i galleriet</span>
                  </span>
                  <i className="fa-regular fa-chevron-right text-xs text-slate-400" />
                </Link>
                <Link
                  to="/om-os"
                  className="flex items-center justify-between p-3 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm font-semibold text-slate-700 hover:text-brand-accent hover:border-brand-accent transition-all"
                >
                  <span className="flex items-center gap-2.5">
                    <i className="fa-regular fa-building-user text-brand-accent" />
                    <span>Læs om Pabst Teknik</span>
                  </span>
                  <i className="fa-regular fa-chevron-right text-xs text-slate-400" />
                </Link>
              </div>

              {/* Quick Contact Box */}
              <div className="rounded-2xl bg-brand-dark text-white p-8 shadow-xl relative overflow-hidden">
                <div className="absolute inset-0 opacity-5">
                  <img
                    src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-house-scaled-66-11zon.webp"
                    alt="Pabst Teknik portservice og sikring i Vejen"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="relative z-10 flex flex-col gap-6">
                  <h3 className="font-display text-xl font-bold text-white">Få et uforpligtende tilbud</h3>
                  <p className="text-sm text-slate-300 leading-relaxed">
                    Har du spørgsmål til denne ydelse, eller ønsker du et skræddersyet tilbud? Ring eller skriv til os med det samme.
                  </p>
                  <div className="flex flex-col gap-4 text-sm border-t border-white/10 pt-6">
                    <div className="flex items-center gap-3">
                      <i className="fa-regular fa-phone text-brand-accent text-base" />
                      <a href="tel:+4521684422" className="hover:text-brand-accent transition-colors">21 68 44 22</a>
                    </div>
                    <div className="flex items-center gap-3">
                      <i className="fa-regular fa-envelope text-brand-accent text-base" />
                      <a href="mailto:kontakt@pabstteknik.dk" className="hover:text-brand-accent transition-colors">kontakt@pabstteknik.dk</a>
                    </div>
                  </div>
                  <Link
                    to="/kontakt"
                    className="mt-2 flex items-center justify-center gap-2 rounded-xl bg-brand-accent py-3.5 text-sm font-bold text-white shadow-lg transition-all hover:bg-brand-accent-hover"
                  >
                    <span>Gå til kontaktformular</span>
                    <i className="fa-regular fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
